import { ILeague } from "core-integration/src/store/leagues/types";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";

interface ReportNameButtonProps {
  entryId?: number;
  league?: ILeague;
}

const ReportNameButton = ({ entryId, league }: ReportNameButtonProps) => {
  const { t } = useTranslation();
  // We only want one or the other so return nothing if both or neither.
  if ((entryId && league) || (!entryId && !league)) {
    return null;
  }
  return (
    <ButtonLink
      to={`/help/report-name?${entryId ? `entryId=${entryId}` : ""}${
        league ? `leagueId=${league.id}&leagueName=${league.name}` : ""
      }`}
      appearance="outlined"
      size="small"
      fullWidth
    >
      {t("reportNameButton", "Report Offensive Name")}
    </ButtonLink>
  );
};
export default ReportNameButton;
